export function CssBp() {
    // List of projects
    const projects = [
      "Creating a Personal Portfolio Page",
      "Building a Simple Blog Layout",
      "Designing a Landing Page",
      "Crafting an eCommerce Page",
      "Developing a Recipe Page",
      "Building a Small Business Homepage",
      "Creating an Event Invitation Page",
    ];
  
    return (
      <>
        <h1 className="html_gfg_heading">
          These are the <strong style={{ textDecoration: "underline", color: "blue" }}>Top 7</strong> recommended Main Projects that you can do with this Project Ideas
        </h1>
  
        <h4 className="des_bp_html">
          1. Do with your own<strong> Main </strong>knowing Concepts. <br />
          2. Ask GPT to clarify your doubts. <br />
          3. Enough projects to do this which we are recommending.
        </h4>
  
        {/* Project list */}
        {projects.map((project, index) => (
          <div className="container_html_bp_links" key={index}>
            <p className="vid">Project {index + 1}: {project}</p>
          </div>
        ))}
      </>
    );
  }
  
  export default CssBp;
  